// import React, { useState, useEffect } from "react";
// import { Trash2, Edit, Search } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Apiurl from "../environment/Apiurl";

// function Roles({ toggleSidebar }) {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [activePage, setActivePage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [responseData, setResponseData] = useState([]);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [userPrivileges, setUserPrivileges] = useState({});
//   const [loadingPrivileges, setLoadingPrivileges] = useState(true);
//   const [error, setError] = useState(null);
//   const [showEntries, setShowEntries] = useState("10");

//   const navigate = useNavigate();

//   // Fetch user privileges based on role_id
//   const fetchUserPrivileges = async () => {
//     try {
//       setLoadingPrivileges(true);
//       const userRoleId = localStorage.getItem("role_id") || "unknown";
//       console.log("Fetching privileges for role_id:", userRoleId); // Debugging
//       if (userRoleId === "unknown") {
//         setError(
//           "No role assigned to the user. Please contact the administrator."
//         );
//         setLoadingPrivileges(false);
//         return;
//       }
//       const response = await axios.get(`${Apiurl}/roles_and_privillage`);
//       console.log("Fetched roles data:", response.data); // Debugging
//       const roleData = response.data.find(
//         (role) => role.role_id === userRoleId
//       );

//       if (roleData) {
//         console.log("Found role data for role_id:", userRoleId, roleData); // Debugging
//         const privileges = {};
//         roleData.pages.forEach((page) => {
//           privileges[page.page] = {
//             access: page.access,
//             ...page.priviallages, // Keep original spelling to match API
//           };
//         });
//         console.log("Set user privileges:", privileges); // Debugging
//         setUserPrivileges(privileges);
//       } else {
//         console.warn("No role data found for role_id:", userRoleId);
//         setError("No role data found for the current user.");
//       }
//     } catch (error) {
//       console.error("Error fetching user privileges:", error.message);
//       setError("Failed to fetch user privileges. Please try again.");
//     } finally {
//       setLoadingPrivileges(false);
//     }
//   };

//   // Fetch roles and privileges
//   const getprivallges = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/roles_and_privillage`);
//       console.log("Fetched roles and privileges:", response.data); // Debugging
//       setResponseData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching roles:", error.message);
//       setError("Failed to fetch roles. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete privileges
//   const delete_privillages = async (_id) => {
//     setLoading(true);
//     try {
//       await axios.delete(`${Apiurl}/roles_and_privillage/${_id}`);
//       console.log("Deleted role with ID:", _id); // Debugging
//       getprivallges();
//     } catch (error) {
//       console.error("Error deleting role:", error.message);
//       setError("Failed to delete role. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Check if user has specific permission for Roles page
//   const hasPermission = (permission) => {
//     if (!userPrivileges || !userPrivileges["Roles"]) {
//       console.log("No user privileges or Roles page data found"); // Debugging
//       return false;
//     }
//     const privileges = userPrivileges["Roles"];
//     console.log(`Checking permission '${permission}' for Roles:`, privileges); // Debugging
//     // Explicitly check access for 'access' permission
//     if (permission === "access") {
//       return privileges.access === true;
//     }
//     // Specific permissions override 'all'
//     if (permission in privileges && privileges[permission] === false) {
//       console.log(`Permission '${permission}' explicitly denied`); // Debugging
//       return false;
//     }
//     const hasPerm =
//       privileges.access && (privileges.all || privileges[permission]);
//     console.log(`Permission '${permission}' result:`, hasPerm); // Debugging
//     return hasPerm;
//   };

//   const handleAddRoles = () => {
//     if (hasPermission("create")) {
//       console.log("Navigating to add roles page"); // Debugging
//       toggleSidebar();
//       navigate("/roles/add-roles");
//     } else {
//       console.warn("Create permission denied for Roles page"); // Debugging
//       setError("You do not have permission to add roles.");
//     }
//   };

//   const handleLogout = () => {
//     console.log("Logging out and clearing localStorage"); // Debugging
//     localStorage.removeItem("role_id");
//     setUserPrivileges({});
//     navigate("/login"); // Adjust to your login route
//   };

//   useEffect(() => {
//     fetchUserPrivileges();
//   }, []);

//   useEffect(() => {
//     if (hasPermission("access")) {
//       console.log("Fetching roles data due to access permission"); // Debugging
//       if (hasPermission("read")) {
//         getprivallges();
//       } else {
//         console.warn("Read permission denied for Roles page"); // Debugging
//         setError("You do not have permission to view roles.");
//       }
//     } else if (!loadingPrivileges) {
//       console.warn("Access permission denied for Roles page"); // Debugging
//       setError("You do not have permission to access this page.");
//     }
//   }, [userPrivileges, loadingPrivileges]);

//   // Update items per page based on showEntries
//   useEffect(() => {
//     if (showEntries === "All") {
//       setItemsPerPage(responseData.length || 1);
//     } else {
//       setItemsPerPage(Number(showEntries));
//     }
//     setActivePage(1);
//   }, [showEntries, responseData]);

//   // Filter data based on search term
//   const filteredBilling = responseData.filter(
//     (user) =>
//       user.role_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.role_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.pages?.some((p) =>
//         p.page.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//   );

//   // Calculate pagination values
//   const totalPages = Math.ceil(filteredBilling.length / itemsPerPage) || 1;
//   const indexOfLastItem = activePage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredBilling.slice(indexOfFirstItem, indexOfLastItem);
//   const startIndex = (activePage - 1) * itemsPerPage;

//   // Generate page list for pagination
//   const getPageList = () => {
//     const pages = [];
//     if (totalPages <= 7) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (activePage <= 4) {
//         pages.push(1, 2, 3, 4, 5, "...", totalPages);
//       } else if (activePage >= totalPages - 3) {
//         pages.push(
//           1,
//           "...",
//           totalPages - 4,
//           totalPages - 3,
//           totalPages - 2,
//           totalPages - 1,
//           totalPages
//         );
//       } else {
//         pages.push(
//           1,
//           "...",
//           activePage - 1,
//           activePage,
//           activePage + 1,
//           "...",
//           totalPages
//         );
//       }
//     }
//     return pages;
//   };

//   const handlePageClick = (page) => {
//     if (page !== "..." && page !== activePage) {
//       console.log("Navigating to page:", page); // Debugging
//       setActivePage(page);
//     }
//   };

//   const openDeleteModal = (id) => {
//     if (hasPermission("delete")) {
//       console.log("Opening delete modal for role ID:", id); // Debugging
//       setDeleteId(id);
//       setShowDeleteModal(true);
//     } else {
//       console.warn("Delete permission denied for Roles page"); // Debugging
//       setError("You do not have permission to delete roles.");
//     }
//   };

//   const closeDeleteModal = () => {
//     console.log("Closing delete modal"); // Debugging
//     setShowDeleteModal(false);
//     setDeleteId(null);
//     setError(null);
//   };

//   const confirmDelete = () => {
//     if (deleteId) {
//       console.log("Confirming deletion for role ID:", deleteId); // Debugging
//       delete_privillages(deleteId);
//       closeDeleteModal();
//     }
//   };

//   const handleEdit = (id) => {
//     if (hasPermission("update")) {
//       console.log("Navigating to edit role ID:", id); // Debugging
//       navigate(`/roles/add-roles/${id}`);
//     } else {
//       console.warn("Update permission denied for Roles page"); // Debugging
//       setError("You do not have permission to edit roles.");
//     }
//   };

//   return (
//     <div className="p-3">
//       {loadingPrivileges ? (
//         <div>Loading permissions...</div>
//       ) : (
//         <>
//           {hasPermission("access") ? (
//             <>
//               {hasPermission("create") && (
//                 <div className="text-end mt-2">
//                   <button
//                     className="btn btn-sm text-white"
//                     style={{ backgroundColor: "#01AEBE" }}
//                     onClick={handleAddRoles}
//                   >
//                     + Add Roles
//                   </button>
//                 </div>
//               )}

//               {error && (
//                 <div className="alert alert-danger alert-dismissible fade show mt-2">
//                   {error}
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={() => setError(null)}
//                   ></button>
//                 </div>
//               )}

//               <div className="card card-body mt-2">
//                 <div className="bg-white rounded shadow-sm">
//                   <div className="row mb-2">
//                     <div className="col-md-2">
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <i className="fas fa-table"></i>
//                         </span>
//                         <select
//                           className="form-select"
//                           value={showEntries}
//                           onChange={(e) => {
//                             console.log(
//                               "Changing show entries to:",
//                               e.target.value
//                             ); // Debugging
//                             setShowEntries(e.target.value);
//                             setCurrentPage(1);
//                           }}
//                         >
//                           <option value="All">Show All</option>
//                           {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
//                             <option key={n} value={n}>
//                               Show {n}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>
//                     <div className="col-md-7"></div>
//                     <div className="col-md-3">
//                       <div className="d-flex align-items-center">
//                         <div className="position-relative">
//                           <input
//                             type="text"
//                             className="form-control pe-5"
//                             placeholder="Search"
//                             value={searchTerm}
//                             onChange={(e) => {
//                               console.log(
//                                 "Search term changed to:",
//                                 e.target.value
//                               ); // Debugging
//                               setSearchTerm(e.target.value);
//                             }}
//                           />
//                           <Search
//                             size={16}
//                             className="position-absolute text-muted"
//                             style={{
//                               right: "10px",
//                               top: "30%",
//                               transform: "translateY(-50%)",
//                             }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="table-responsive">
//                     <table className="table responsive-table">
//                       <thead
//                         style={{ backgroundColor: "#01AEBE", color: "white" }}
//                       >
//                         <tr>
//                           <th>S.No</th>
//                           <th style={{ width: "20%" }}>Roles Name</th>
//                           <th>Modules</th>
//                           {(hasPermission("update") ||
//                             hasPermission("delete")) && <th>Action</th>}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {loading ? (
//                           <tr>
//                             <td
//                               colSpan={
//                                 hasPermission("update") ||
//                                 hasPermission("delete")
//                                   ? 4
//                                   : 3
//                               }
//                               className="text-center py-4"
//                             >
//                               Loading...
//                             </td>
//                           </tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((user, index) => (
//                             <tr key={user._id} className="align-middle">
//                               <td>{startIndex + index + 1}</td>
//                               <td>{user.role_name}</td>
//                               <td
//                                 style={{
//                                   textAlign: "justify",
//                                   display: "-webkit-box",
//                                   WebkitLineClamp: 2,
//                                   WebkitBoxOrient: "vertical",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                   lineHeight: "1.4em",
//                                   maxHeight: "55px", // 2 lines * 1.4em line-height
//                                 }}
//                                 title={user.pages
//                                   .filter((p) => p.access)
//                                   .map((p) => p.page)
//                                   .join(", ")} // Full text on hover
//                               >
//                                 {user.pages
//                                   .filter((p) => p.access)
//                                   .map((p) => p.page)
//                                   .join(", ")}
//                               </td>

//                               {(hasPermission("update") ||
//                                 hasPermission("delete")) && (
//                                 <td>
//                                   {user.role_id !== "Roles-001" && (
//                                     <>
//                                       {hasPermission("delete") && (
//                                         <button
//                                           className="btn btn-sm p-1 border-0"
//                                           title="Delete"
//                                           onClick={() =>
//                                             openDeleteModal(user._id)
//                                           }
//                                         >
//                                           <Trash2
//                                             size={16}
//                                             className="text-danger"
//                                           />
//                                         </button>
//                                       )}
//                                       {hasPermission("update") && (
//                                         <button
//                                           className="btn btn-sm p-1 border-0"
//                                           title="Edit"
//                                           onClick={() => handleEdit(user._id)}
//                                         >
//                                           <Edit
//                                             size={16}
//                                             className="text-primary"
//                                           />
//                                         </button>
//                                       )}
//                                     </>
//                                   )}
//                                 </td>
//                               )}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td
//                               colSpan={
//                                 hasPermission("update") ||
//                                 hasPermission("delete")
//                                   ? 4
//                                   : 3
//                               }
//                               className="text-center py-4"
//                             >
//                               No roles found
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   <div className="container">
//                     <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
//                       <button
//                         className="btn btn-outline-secondary d-flex align-items-center gap-2"
//                         onClick={() =>
//                           activePage > 1 && handlePageClick(activePage - 1)
//                         }
//                         disabled={activePage === 1}
//                       >
//                         <i className="fas fa-chevron-left"></i>
//                         <span className="d-none d-sm-inline">Previous</span>
//                       </button>

//                       <div
//                         className="d-flex overflow-auto flex-nowrap gap-2 px-2"
//                         style={{ maxWidth: "100%" }}
//                       >
//                         {getPageList().map((page, index) => (
//                           <button
//                             key={index}
//                             className={`btn btn-sm px-3 flex-shrink-0 ${
//                               page === activePage
//                                 ? "text-white"
//                                 : "btn-outline-secondary"
//                             }`}
//                             style={
//                               page === activePage
//                                 ? { backgroundColor: "#20c997", border: "none" }
//                                 : {}
//                             }
//                             onClick={() => handlePageClick(page)}
//                             disabled={page === "..."}
//                           >
//                             {page}
//                           </button>
//                         ))}
//                       </div>

//                       <button
//                         className="btn btn-outline-secondary d-flex align-items-center gap-2"
//                         onClick={() =>
//                           activePage < totalPages &&
//                           handlePageClick(activePage + 1)
//                         }
//                         disabled={activePage === totalPages}
//                       >
//                         <span className="d-none d-sm-inline">Next</span>
//                         <i className="fas fa-chevron-right"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {hasPermission("delete") && (
//                 <div
//                   className={`modal fade ${showDeleteModal ? "show" : ""}`}
//                   style={{
//                     display: showDeleteModal ? "block" : "none",
//                     backgroundColor: "rgba(0,0,0,0.5)",
//                   }}
//                   tabIndex="-1"
//                   role="dialog"
//                   aria-labelledby="deleteRoleModalLabel"
//                   aria-modal="true"
//                 >
//                   <div className="modal-dialog modal-sm modal-dialog-centered">
//                     <div
//                       className="modal-content"
//                       style={{ borderRadius: "10px" }}
//                     >
//                       <div
//                         className="modal-header"
//                         style={{ borderBottom: "none" }}
//                       >
//                         <button
//                           type="button"
//                           className="btn-close"
//                           onClick={closeDeleteModal}
//                           aria-label="Close"
//                         ></button>
//                       </div>
//                       <div className="modal-body text-center">
//                         <div style={{ marginBottom: "15px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               width: "40px",
//                               height: "40px",
//                               backgroundColor: "#fee2e2",
//                               borderRadius: "50%",
//                               textAlign: "center",
//                               lineHeight: "40px",
//                             }}
//                           >
//                             <i
//                               className="fas fa-exclamation-triangle"
//                               style={{ color: "#dc2626", fontSize: "20px" }}
//                             ></i>
//                           </span>
//                         </div>
//                         <h5 className="modal-title" id="deleteRoleModalLabel">
//                           Delete Role
//                         </h5>
//                         <p style={{ marginTop: "10px" }}>
//                           You're going to delete this role. Are you sure?
//                         </p>
//                       </div>
//                       <div
//                         className="modal-footer"
//                         style={{ borderTop: "none", justifyContent: "center" }}
//                       >
//                         <button
//                           type="button"
//                           className="btn btn-secondary btn-sm"
//                           style={{
//                             marginRight: "10px",
//                             backgroundColor: "#e0e0e0",
//                             color: "#333",
//                           }}
//                           onClick={closeDeleteModal}
//                         >
//                           No, Keep it
//                         </button>
//                         <button
//                           type="button"
//                           className="btn btn-danger btn-sm"
//                           onClick={confirmDelete}
//                         >
//                           Yes, Delete It!
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           ) : (
//             <div className="alert alert-danger mt-2">
//               You do not have permission to access this page.
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }

// export default Roles;

import React, { useState, useEffect } from "react";
import { Trash2, Edit, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

function Roles({ toggleSidebar }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [userPrivileges, setUserPrivileges] = useState({});
  const [loadingPrivileges, setLoadingPrivileges] = useState(true);
  const [error, setError] = useState(null);
  const [showEntries, setShowEntries] = useState("10");

  const navigate = useNavigate();

  // Fetch user privileges based on role_id
  const fetchUserPrivileges = async () => {
    try {
      setLoadingPrivileges(true);
      const userRoleId = localStorage.getItem("role_id") || "unknown";
      console.log("Fetching privileges for role_id:", userRoleId);
      if (userRoleId === "unknown") {
        setError(
          "No role assigned to the user. Please contact the administrator."
        );
        setLoadingPrivileges(false);
        return;
      }
      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Fetched roles data:", response.data);
      const roleData = response.data.find(
        (role) => role.role_id === userRoleId
      );

      if (roleData) {
        console.log("Found role data for role_id:", userRoleId, roleData);
        const privileges = {};
        roleData.pages.forEach((page) => {
          privileges[page.page] = {
            access: page.access,
            ...page.priviallages,
          };
        });
        console.log("Set user privileges:", privileges);
        setUserPrivileges(privileges);
      } else {
        console.warn("No role data found for role_id:", userRoleId);
        setError("No role data found for the current user.");
      }
    } catch (error) {
      console.error("Error fetching user privileges:", error.message);
      setError("Failed to fetch user privileges. Please try again.");
    } finally {
      setLoadingPrivileges(false);
    }
  };

  // Fetch roles and privileges
  const getprivallges = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Fetched roles and privileges:", response.data);
      setResponseData(response.data || []);
    } catch (error) {
      console.error("Error fetching roles:", error.message);
      setError("Failed to fetch roles. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Delete privileges
  const delete_privillages = async (_id) => {
    setLoading(true);
    try {
      await axios.delete(`${Apiurl}/roles_and_privillage/${_id}`);
      console.log("Deleted role with ID:", _id);
      getprivallges();
    } catch (error) {
      console.error("Error deleting role:", error.message);
      setError("Failed to delete role. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Check if user has specific permission for Roles page
  const hasPermission = (permission) => {
    if (!userPrivileges || !userPrivileges["Roles"]) {
      console.log("No user privileges or Roles page data found");
      return false;
    }
    const privileges = userPrivileges["Roles"];
    console.log(`Checking permission '${permission}' for Roles:`, privileges);
    if (permission === "access") {
      return privileges.access === true;
    }
    if (permission in privileges && privileges[permission] === false) {
      console.log(`Permission '${permission}' explicitly denied`);
      return false;
    }
    const hasPerm =
      privileges.access && (privileges.all || privileges[permission]);
    console.log(`Permission '${permission}' result:`, hasPerm);
    return hasPerm;
  };

  const handleAddRoles = () => {
    if (hasPermission("create")) {
      console.log("Navigating to add roles page");
      toggleSidebar();
      navigate("/roles/add-roles");
    } else {
      console.warn("Create permission denied for Roles page");
      setError("You do not have permission to add roles.");
    }
  };

  const handleLogout = () => {
    console.log("Logging out and clearing localStorage");
    localStorage.removeItem("role_id");
    setUserPrivileges({});
    navigate("/login");
  };

  useEffect(() => {
    fetchUserPrivileges();
  }, []);

  useEffect(() => {
    if (hasPermission("access")) {
      console.log("Fetching roles data due to access permission");
      if (hasPermission("read")) {
        getprivallges();
      } else {
        console.warn("Read permission denied for Roles page");
        setError("You do not have permission to view roles.");
      }
    } else if (!loadingPrivileges) {
      console.warn("Access permission denied for Roles page");
      setError("You do not have permission to access this page.");
    }
  }, [userPrivileges, loadingPrivileges]);

  useEffect(() => {
    if (showEntries === "All") {
      setItemsPerPage(responseData.length || 1);
    } else {
      setItemsPerPage(Number(showEntries));
    }
    setActivePage(1);
  }, [showEntries, responseData]);

  // Filter data based on search term
  const filteredBilling = responseData.filter(
    (user) =>
      user.role_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.role_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.pages?.some((p) =>
        p.page.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  // Calculate pagination values
  const totalPages = Math.ceil(filteredBilling.length / itemsPerPage) || 1;
  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBilling.slice(indexOfFirstItem, indexOfLastItem);
  const startIndex = (activePage - 1) * itemsPerPage;

  // Generate page list for pagination
  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (activePage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (activePage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          activePage - 1,
          activePage,
          activePage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page !== "..." && page !== activePage) {
      console.log("Navigating to page:", page);
      setActivePage(page);
    }
  };

  const openDeleteModal = (id) => {
    if (hasPermission("delete")) {
      console.log("Opening delete modal for role ID:", id);
      setDeleteId(id);
      setShowDeleteModal(true);
    } else {
      console.warn("Delete permission denied for Roles page");
      setError("You do not have permission to delete roles.");
    }
  };

  const closeDeleteModal = () => {
    console.log("Closing delete modal");
    setShowDeleteModal(false);
    setDeleteId(null);
    setError(null);
  };

  const confirmDelete = () => {
    if (deleteId) {
      console.log("Confirming deletion for role ID:", deleteId);
      delete_privillages(deleteId);
      closeDeleteModal();
    }
  };

  const handleEdit = (id) => {
    if (hasPermission("update")) {
      console.log("Navigating to edit role ID:", id);
      navigate(`/roles/add-roles/${id}`);
    } else {
      console.warn("Update permission denied for Roles page");
      setError("You do not have permission to edit roles.");
    }
  };

  return (
    <div className="p-3">
      {loadingPrivileges ? (
        <div>Loading permissions...</div>
      ) : (
        <>
          {hasPermission("access") ? (
            <>
              {hasPermission("create") && (
                <div className="text-end mt-2">
                  <button
                    className="btn btn-sm text-white"
                    style={{ backgroundColor: "#01AEBE" }}
                    onClick={handleAddRoles}
                  >
                    + Add Roles
                  </button>
                </div>
              )}

              {error && (
                <div className="alert alert-danger alert-dismissible fade show mt-2">
                  {error}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setError(null)}
                  ></button>
                </div>
              )}

              <div className="card card-body mt-2">
                <div className="bg-white rounded shadow-sm">
                  <div className="row mb-2 crm-table-toolbar">
                    <div className="col-md-2">
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fas fa-table"></i>
                        </span>
                        <select
                          className="form-select"
                          value={showEntries}
                          onChange={(e) => {
                            console.log(
                              "Changing show entries to:",
                              e.target.value
                            );
                            setShowEntries(e.target.value);
                            setCurrentPage(1);
                          }}
                        >
                          <option value="All">Show All</option>
                          {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
                            <option key={n} value={n}>
                              Show {n}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-7"></div>
                    <div className="col-md-3">
                      <div className="d-flex align-items-center">
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control pe-5"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => {
                              console.log(
                                "Search term changed to:",
                                e.target.value
                              );
                              setSearchTerm(e.target.value);
                            }}
                          />
                          <Search
                            size={16}
                            className="position-absolute text-muted"
                            style={{
                              right: "10px",
                              top: "30%",
                              transform: "translateY(-50%)",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table responsive-table">
                      <thead
                        style={{ backgroundColor: "#01AEBE", color: "white" }}
                      >
                        <tr>
                          <th>S.No</th>
                          <th style={{ width: "20%" }}>Roles Name</th>
                          <th>Modules</th>
                          {(hasPermission("update") ||
                            hasPermission("delete")) && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td
                              colSpan={
                                hasPermission("update") ||
                                hasPermission("delete")
                                  ? 4
                                  : 3
                              }
                              className="text-center py-4"
                            >
                              Loading...
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((user, index) => (
                            <tr key={user._id} className="align-middle">
                              <td>{startIndex + index + 1}</td>
                              <td>{user.role_name}</td>
                              <td>
                                <div
                                  style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    lineHeight: "1.4em",
                                    maxHeight: "2.8em", // 2 lines * 1.4em line-height
                                    minHeight: "2.8em", // Ensure consistent height
                                    textAlign: "justify",
                                  }}
                                  title={user.pages
                                    .filter((p) => p.access)
                                    .map((p) => p.page)
                                    .join(", ")}
                                >
                                  {user.pages
                                    .filter((p) => p.access)
                                    .map((p) => p.page)
                                    .join(", ")}
                                </div>
                              </td>

                              {(hasPermission("update") ||
                                hasPermission("delete")) && (
                                <td>
                                  {user.role_id !== "Roles-001" && (
                                    <>
                                      {hasPermission("delete") && (
                                        <button
                                          className="btn btn-sm p-1 border-0"
                                          title="Delete"
                                          onClick={() =>
                                            openDeleteModal(user._id)
                                          }
                                        >
                                          <Trash2
                                            size={16}
                                            className="text-danger"
                                          />
                                        </button>
                                      )}
                                      {hasPermission("update") && (
                                        <button
                                          className="btn btn-sm p-1 border-0"
                                          title="Edit"
                                          onClick={() => handleEdit(user._id)}
                                        >
                                          <Edit
                                            size={16}
                                            className="text-primary"
                                          />
                                        </button>
                                      )}
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                hasPermission("update") ||
                                hasPermission("delete")
                                  ? 4
                                  : 3
                              }
                              className="text-center py-4"
                            >
                              No roles found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="container">
                    <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                      <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2"
                        onClick={() =>
                          activePage > 1 && handlePageClick(activePage - 1)
                        }
                        disabled={activePage === 1}
                      >
                        <i className="fas fa-chevron-left"></i>
                        <span className="d-none d-sm-inline">Previous</span>
                      </button>

                      <div
                        className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                        style={{ maxWidth: "100%" }}
                      >
                        {getPageList().map((page, index) => (
                          <button
                            key={index}
                            className={`btn btn-sm px-3 flex-shrink-0 ${
                              page === activePage
                                ? "text-white"
                                : "btn-outline-secondary"
                            }`}
                            style={
                              page === activePage
                                ? { backgroundColor: "#20c997", border: "none" }
                                : {}
                            }
                            onClick={() => handlePageClick(page)}
                            disabled={page === "..."}
                          >
                            {page}
                          </button>
                        ))}
                      </div>

                      <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2"
                        onClick={() =>
                          activePage < totalPages &&
                          handlePageClick(activePage + 1)
                        }
                        disabled={activePage === totalPages}
                      >
                        <span className="d-none d-sm-inline">Next</span>
                        <i className="fas fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {hasPermission("delete") && (
                <div
                  className={`modal fade ${showDeleteModal ? "show" : ""}`}
                  style={{
                    display: showDeleteModal ? "block" : "none",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="deleteRoleModalLabel"
                  aria-modal="true"
                >
                  <div className="modal-dialog modal-sm modal-dialog-centered">
                    <div
                      className="modal-content"
                      style={{ borderRadius: "10px" }}
                    >
                      <div
                        className="modal-header"
                        style={{ borderBottom: "none" }}
                      >
                        <button
                          type="button"
                          className="btn-close"
                          onClick={closeDeleteModal}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body text-center">
                        <div style={{ marginBottom: "15px" }}>
                          <span
                            style={{
                              display: "inline-block",
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#fee2e2",
                              borderRadius: "50%",
                              textAlign: "center",
                              lineHeight: "40px",
                            }}
                          >
                            <i
                              className="fas fa-exclamation-triangle"
                              style={{ color: "#dc2626", fontSize: "20px" }}
                            ></i>
                          </span>
                        </div>
                        <h5 className="modal-title" id="deleteRoleModalLabel">
                          Delete Role
                        </h5>
                        <p style={{ marginTop: "10px" }}>
                          You're going to delete this role. Are you sure?
                        </p>
                      </div>
                      <div
                        className="modal-footer"
                        style={{ borderTop: "none", justifyContent: "center" }}
                      >
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          style={{
                            marginRight: "10px",
                            backgroundColor: "#e0e0e0",
                            color: "#333",
                          }}
                          onClick={closeDeleteModal}
                        >
                          No, Keep it
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={confirmDelete}
                        >
                          Yes, Delete It!
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="alert alert-danger mt-2">
              You do not have permission to access this page.
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Roles;
